// Yahoo!ショッピング の手数料率。楽天の rakutenFeeRates.js / Shopify の shopifyFeeRates.js に相当する。
// 出典: https://business-ec.yahoo.co.jp/shopping/ (2026-08 時点)
//
// 楽天と違い「出店料・システム利用料」が無料で、代わりに売上に対する
// 以下の率が都度かかるのが Yahoo の特徴。プランによる分岐も無いためテーブルは平坦。
//
//   - ストアポイント原資     … 標準1%(ストアが任意で最大15%まで上乗せ)
//   - キャンペーン原資       … 標準1.5%(固定)
//   - アフィリエイトパートナー報酬 … 標準1%(ストアが0.1%〜設定可)
//   - アフィリエイト手数料   … 上記報酬額の30%(Yahoo への手数料)
//   - 決済サービス個別手数料 … 決済方法により 3.0%前後。既定はクレカ相当の3.0%
//
// ★ストアごとに設定を変えられる項目は shop に率を持たせ、未設定なら以下の既定値を使う。

// ストアポイント原資の既定倍率(1倍 = 1%)
const DEFAULT_POINT_RATE = 1;

// キャンペーン原資(固定1.5%)。ストア側で変更できないため定数
const CAMPAIGN_COST_RATE = 0.015;

// アフィリエイトパートナー報酬の既定料率(1%)
const DEFAULT_AFFILIATE_RATE = 0.01;

// アフィリエイト手数料 = パートナー報酬額 × 30%
const AFFILIATE_FEE_RATE = 0.3;

// 決済サービス個別手数料の既定料率(3.0%)。
// 実際は決済手段ごとに異なる(クレカ3.0% / PayPay残高等)が、
// 注文単位で決済手段別の率を持つのは過剰なため既定率で推定する。
const DEFAULT_PAYMENT_RATE = 0.03;

// ストアポイント原資率を返す。shop.yahooPointRate は「倍率」(1 = 1%)
const computePointRate = (pointRate) => Math.max(Number(pointRate ?? DEFAULT_POINT_RATE) || 0, 0) * 0.01;

// アフィリエイトパートナー報酬率を返す。shop.yahooAffiliateRate は「%」で保持する
const computeAffiliateRate = (affiliateRate) => {
  const rate = affiliateRate == null ? DEFAULT_AFFILIATE_RATE * 100 : Number(affiliateRate);
  return Math.max(Number.isFinite(rate) ? rate : DEFAULT_AFFILIATE_RATE * 100, 0) * 0.01;
};

// 決済サービス個別手数料率を返す。shop.yahooPaymentRate は「%」で保持する
const computePaymentRate = (paymentRate) => {
  const rate = paymentRate == null ? DEFAULT_PAYMENT_RATE * 100 : Number(paymentRate);
  return Math.max(Number.isFinite(rate) ? rate : DEFAULT_PAYMENT_RATE * 100, 0) * 0.01;
};

exports.DEFAULT_POINT_RATE = DEFAULT_POINT_RATE;
exports.CAMPAIGN_COST_RATE = CAMPAIGN_COST_RATE;
exports.DEFAULT_AFFILIATE_RATE = DEFAULT_AFFILIATE_RATE;
exports.AFFILIATE_FEE_RATE = AFFILIATE_FEE_RATE;
exports.DEFAULT_PAYMENT_RATE = DEFAULT_PAYMENT_RATE;
exports.computePointRate = computePointRate;
exports.computeAffiliateRate = computeAffiliateRate;
exports.computePaymentRate = computePaymentRate;
